import className from "~/kernel/styling/className";

export type ContainerSize = "xsmall" | "small" | "medium" | "large" | "full";

export default function Container({
  children,
  size = "medium",
}: {
  children: React.ReactNode;
  size?: ContainerSize;
}) {
  return (
    <div
      className={className("mx-auto px-2 text-slate-600 md:px-5", {
        "max-w-8xl container": size === "large",
        "container max-w-5xl": size === "medium",
        "container max-w-3xl": size === "small",
        "container max-w-xl": size === "xsmall",
      })}
    >
      {children}
    </div>
  );
}
